import { client } from '../common/client';
import type { BannerResponse, GetBannersRequest } from './utils/types';

/**
 * API client for banner-related operations
 */
class BannerAPIClient {
  /**
   * Fetch banners for display
   * @param params - Request parameters including location
   * @returns Promise with banner data
   */
  public async getBanners(params: GetBannersRequest) {
    return await client.get<BannerResponse>('/banners', { params }).then((res) => res.data);
  }
}

export const bannerAPIClient = new BannerAPIClient();
